import { useContext } from 'react'

import { NavBlockerContext } from './NavBlockerContext'

export const useNavBlockerContext = () => {
  const context = useContext(NavBlockerContext)

  if (!context)
    throw new Error(
      'You forgot to wrap your component in <NavBlockerContextProvider>',
    )

  return context
}
